import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { WarningCircle } from "@phosphor-icons/react";
import api from "@/lib/api";
import { errText } from "./useLegalAdmin";

const INPUT = "w-full border-2 border-black px-3 py-2 text-sm mt-1 bg-white disabled:bg-zinc-50";

export const LegalGoLiveBanner = ({ missing, testId = "legal-golive-banner" }) => {
  if (!missing?.length) return null;
  return (
    <div className="border-2 border-red-700 bg-red-50 text-red-900 px-3 py-2 text-xs flex items-start gap-2" data-testid={testId}>
      <WarningCircle size={16} weight="fill" className="shrink-0 mt-0.5" />
      <div>
        <b>Before going live:</b> add your {missing.join(" and ")}. Your Privacy Policy, Terms and Legal Partners pages
        show a visible placeholder until you do.
      </div>
    </div>
  );
};

export const LegalContactCard = ({ contact, canEdit, onSaved }) => {
  const [address, setAddress] = useState(contact.business_address);
  const [email, setEmail] = useState(contact.privacy_email);
  const [phone, setPhone] = useState(contact.privacy_phone || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setAddress(contact.business_address); setEmail(contact.privacy_email); setPhone(contact.privacy_phone || "");
  }, [contact]);
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/legal/contact", { business_address: address, privacy_email: email, privacy_phone: phone });
      toast.success("Contact details saved");
      onSaved();
    } catch (e) { toast.error(errText(e, "Couldn't save")); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col gap-3" data-testid="legal-contact-card">
      <LegalGoLiveBanner missing={contact.missing} />
      <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_auto] gap-3 items-end">
        <label className="block">
          <span className="label-mono">Business mailing address (shown on legal pages)</span>
          <input className={INPUT} value={address} onChange={(e) => setAddress(e.target.value)} disabled={!canEdit} data-testid="legal-contact-address" />
        </label>
        <label className="block">
          <span className="label-mono">Privacy contact email</span>
          <input type="email" className={INPUT} value={email} onChange={(e) => setEmail(e.target.value)} disabled={!canEdit} data-testid="legal-contact-email" />
        </label>
        <label className="block">
          <span className="label-mono">Privacy contact phone</span>
          <input type="tel" className={INPUT} value={phone} onChange={(e) => setPhone(e.target.value)} disabled={!canEdit} data-testid="legal-contact-phone" />
        </label>
        {canEdit && (
          <button type="button" onClick={save} disabled={busy} data-testid="legal-contact-save"
                  className="border-2 border-black bg-black text-white px-3 py-2 text-[10px] uppercase tracking-widest disabled:opacity-40">
            {busy ? "Saving…" : "Save"}
          </button>
        )}
      </div>
    </div>
  );
};
